/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileNwc = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M14.414 2H4v20h16v-3h-2v1H6V4h7v5h5v1h2V7.586zm2.172 5H15V5.414z" />
        <path d="M22.794 16.806v-.871c-.255.089-.48.156-.677.2-.192.04-.382.061-.57.061-.468 0-.824-.145-1.065-.435-.24-.295-.362-.713-.362-1.253 0-.5.123-.887.369-1.16.246-.272.599-.408 1.059-.408.16 0 .326.018.495.053.175.036.38.099.617.188v-.884a2.519 2.519 0 0 0-.53-.188 2.759 2.759 0 0 0-.656-.074c-.5 0-.931.1-1.293.302-.362.196-.641.48-.838.85-.196.367-.295.807-.295 1.32 0 .836.202 1.477.604 1.924.402.442.993.663 1.775.663.277 0 .53-.03.757-.087.232-.054.436-.12.61-.201zM7.89 17v-4.87h.965l2.104 3.168V12.13h1.031V17h-.964l-2.104-3.176V17zm5.768 0-1.078-4.87h1.058l.69 3.282.871-3.015h.865l.91 2.975.684-3.243h1.032L17.61 17h-1.005l-.998-3.276L14.663 17z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileNwc as FileNwc };
